import { Action, combineReducers, createFeatureSelector, createReducer, createSelector, on } from '@ngrx/store';
import * as fromCards from './add-card.reducer';
import * as fromCheckCardStatus from './check-card-status.reducer';
import * as checkCardStatusReducer from '../reducers/check-card-status.reducer';

export const addCreditCardFeatureKey = 'creditCard';

export interface CreditCardState {
  [fromCards.addCardFeatureKey]: fromCards.CardState;
  [fromCheckCardStatus.checkCardStatusFeatureKey]: fromCheckCardStatus.CheckCardStatusState;
}

export interface State {
  [addCreditCardFeatureKey]: CreditCardState;
}

export function reducers(state: CreditCardState | undefined, action: Action) {
  return combineReducers({
    [fromCards.addCardFeatureKey]: fromCards.reducer,
    [fromCheckCardStatus.checkCardStatusFeatureKey]: fromCheckCardStatus.reducer
  })(state, action);
}

//#region CHECK CARD STATUS
//Select root state
export const selectCreditCardState = createFeatureSelector<State, checkCardStatusReducer.CheckCardStatusState>(addCreditCardFeatureKey);

//select feature state
export const getCheckCardStatusState = createSelector(
  selectCreditCardState,
  state => state[checkCardStatusReducer.checkCardStatusFeatureKey]
);
//#endregion
